import { DEFAULT_REGIONS } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';

const getSelectedRegion = () => {
    const { candidateStore } = getStore();
    const selectedRegion =
        candidateStore.regions.find((region) => region.id === candidateStore.selectedRegionId) || DEFAULT_REGIONS[0];
    return selectedRegion;
};

export default getSelectedRegion;
